var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip-group',{attrs:{"column":""}},_vm._l((_vm.activeTags),function(tag){return _c('v-chip',{key:tag,attrs:{"small":"","color":"primary"}},[_vm._v(" "+_vm._s(tag)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }